import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid } from "@material-ui/core";
import { logEvents } from "../../redux/commonActions";
import {
  PUBLIC_FOOTER_FB,
  PUBLIC_FOOTER_INSTAGRAM,
  PUBLIC_FOOTER_TWITTER
} from "../../services/webengage/webEngageConstants";
import {
  FB_LINK,
  INSTA_LINK,
  TWITTER_LINK
} from "../../containers/Home/homeConstants";
import IconText from "../IconText";

class SocialMedia extends React.Component {
  handleClick = (url, evntType) => () => {
    this.props.logEvents(evntType);
    window.open(url, "_blank");
  };
  render() {
    const { classes } = this.props;
    return (
      <Grid item className={classes.footerItem}>
        <div className={classes.heading}>Social</div>
        <Grid item>
          <span
            className={classes.subHeading}
            onClick={this.handleClick(FB_LINK, PUBLIC_FOOTER_FB)}
          >
            <IconText
              dataSrc="/hire/facebook.svg"
              height="14px"
              width="14px"
              alt="Facebook Logo"
            >
              Facebook
            </IconText>
          </span>
        </Grid>
        <Grid item>
          <span
            className={classes.subHeading}
            onClick={this.handleClick(INSTA_LINK, PUBLIC_FOOTER_INSTAGRAM)}
          >
            <IconText
              dataSrc="/hire/instagram.svg"
              height="14px"
              width="14px"
              alt="Instagram Logo"
            >
              Instagram
            </IconText>
          </span>
        </Grid>
        <Grid item>
          <span
            className={classes.subHeading}
            onClick={this.handleClick(TWITTER_LINK, PUBLIC_FOOTER_TWITTER)}
          >
            <IconText
              dataSrc="/hire/twitter.svg"
              height="14px"
              width="14px"
              alt="Twitter Logo"
            >
              Twitter
            </IconText>
          </span>
        </Grid>
      </Grid>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ logEvents }, dispatch);
};

export default connect(null, mapDispatchToProps)(SocialMedia);
